





















import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import userSettings from "@/components/userSettings.vue";
import teamChange from "@/components/teamChange.vue";
import configureReviewersType from "@/components/review/configureReviewersType.vue";
import configureReviewersCustom from "@/components/review/configureReviewersCustom.vue";
import {
  Team,
  User,
  ConfigureReviewerEnum,
  TeamReviewSettings
} from "../../types";
import { Getter, Action } from "vuex-class";
import { fetchTeamReviewSettings, updateTeamReviewSettings } from "@/api.ts";

@Component({
  components: {
    userSettings,
    teamChange,
    configureReviewersType,
    configureReviewersCustom
  }
})
export default class ConfigureReviewers extends Vue {
  @Getter private JWT!: string;
  @Getter private currentTeamUsers?: User[];
  @Getter private currentTeam?: Team;
  @Getter private currentTeamID!: string;
  @Getter private teamReviewSettings?: TeamReviewSettings;
  @Action private setTeamReviewSettings!: any;
  @Action private setDisplayError: any;
  @Prop() private changeTeam!: (teamID: any) => any;

  private configureCustomType = ConfigureReviewerEnum.Custom;
  private configureType: ConfigureReviewerEnum = ConfigureReviewerEnum.Empty;

  private created() {
    this.setTeamReviewSettings(null);
  }

  private onConfigureType(configureType: ConfigureReviewerEnum) {
    this.configureType = configureType;

    if (this.teamReviewSettings) {
      this.teamReviewSettings.method = this.configureType;
      this.teamReviewSettings.reviewers = [];
      this.updateTeamReviewSettings();
    }
  }

  @Watch("currentTeam", { immediate: true })
  private onCurrentTeamChange() {
    this.fetchTeamReviewSettings();
  }

  private updateTeamReviewSettings() {
    if (this.teamReviewSettings) {
    
      updateTeamReviewSettings(
        this.JWT,
        this.currentTeamID,
        this.teamReviewSettings,
        (teamReviewSettings: TeamReviewSettings) => {
          
          this.setTeamReviewSettings(teamReviewSettings);
        },
        (error: string) => {
          this.setDisplayError(error);
        }
      );
    }
  }

  private fetchTeamReviewSettings() {
    if (this.currentTeamID) {
      fetchTeamReviewSettings(
        this.JWT,
        this.currentTeamID,
        (teamReviewSettings: TeamReviewSettings) => {
          this.setTeamReviewSettings(teamReviewSettings);
          this.configureType = teamReviewSettings.method;
        },
        (error: string) => {
          this.setDisplayError(error);
        }
      );
    }
  }
}
